import React from "react";
import PropTypes from "prop-types";

// styles
import { BatchTitleStyled } from "./styles.js";

export const BatchTitle = ({ text }) => {
    if (!text) return null;
    return <BatchTitleStyled>{text}</BatchTitleStyled>;
};

export default BatchTitle;

// prop-types
BatchTitle.propTypes = {
    text: PropTypes.string
};
